import { render, staticRenderFns } from "./EventModalCatalogFooter.vue?vue&type=template&id=da5753cc&scoped=true"
import script from "./EventModalCatalogFooter.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogFooter.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogFooter.vue?vue&type=style&index=0&id=da5753cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5753cc",
  null
  
)

export default component.exports